<app-school-card (click)="onClick(school)" [school]="school" [view]="design" (changed)="onChange($event)"></app-school-card>
